// --- Analysta | Clean first, then update with Source, Campaign, Content ---

document.addEventListener('DOMContentLoaded', function () {
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      actsce: params.get('actsce'),
      actcgn: params.get('actcgn'),
      actcnt: params.get('actcnt')
    };
  }

  function getCookie(name) {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    for (let cookie of cookies) {
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }

  function setCookieOneHour(name, value) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (1 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; Secure; SameSite=Lax`;
  }

  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json());
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: attributes })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error actualizando atributos del carrito.');
      return response.json();
    });
  }

  // --- Flujo principal: limpiar primero, luego actualizar con nuevos valores si aplica ---
  const { actsce, actcgn, actcnt } = getUrlParams();
  const actupdtok = getCookie('actupdtok');

  getCart()
    .then(cart => {
      const currentAttributes = cart.attributes || {};
      const cleanedAttributes = {};

      // Si ya existían los valores correctos, los conservamos
      if (currentAttributes['Source']) cleanedAttributes['Source'] = currentAttributes['Source'];
      if (currentAttributes['Campaign']) cleanedAttributes['Campaign'] = currentAttributes['Campaign'];
      if (currentAttributes['Content']) cleanedAttributes['Content'] = currentAttributes['Content'];

      // Limpiamos si hay otros atributos no deseados
      const hasInvalidAttributes = Object.keys(currentAttributes).some(key =>
        !['Source', 'Campaign', 'Content'].includes(key)
      );

      const performUpdate = (newAttributes) => {
        return updateCartAttributes(newAttributes)
          .then(data => {
            console.log('Atributos del carrito actualizados:', data);
            setCookieOneHour('actupdtok', 'true');
          });
      };

      if (hasInvalidAttributes) {
        // Primero limpiamos
        updateCartAttributes(cleanedAttributes)
          .then(() => {
            // Después actualizamos si hay parámetros nuevos y no hay cookie
            if ((actsce || actcgn || actcnt) && actupdtok !== 'true') {
              if (actsce) cleanedAttributes['Source'] = actsce;
              if (actcgn) cleanedAttributes['Campaign'] = actcgn;
              if (actcnt) cleanedAttributes['Content'] = actcnt;
              return performUpdate(cleanedAttributes);
            }
          })
          .catch(error => console.error('Error durante la limpieza de atributos:', error));
      } else {
        // Si no hay basura, solo actualizamos si hay parámetros nuevos
        if ((actsce || actcgn || actcnt) && actupdtok !== 'true') {
          if (actsce) cleanedAttributes['Source'] = actsce;
          if (actcgn) cleanedAttributes['Campaign'] = actcgn;
          if (actcnt) cleanedAttributes['Content'] = actcnt;
          return performUpdate(cleanedAttributes);
        }
      }
    })
    .catch(error => console.error('Error obteniendo el carrito:', error));
});